module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Gb-Ha-Ic-Ja.f1978614.png";